import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { GetTemplateCreationRecordResponse } from '../../contracts';
import {
  CREATE_TEMPLATE_CREATION_RECORD_BY_TEMPLATE_ID_KEY,
  GET_TEMPLATE_CREATION_RECORD_BY_ID,
} from '../../contracts';
import { createTemplateCreationRecordByTemplateId } from '../api/templates';

export const useMutateCreateTemplateCreationRecordByTemplateId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [CREATE_TEMPLATE_CREATION_RECORD_BY_TEMPLATE_ID_KEY],
    mutationFn: async (templateId: string) => {
      return await createTemplateCreationRecordByTemplateId(templateId);
    },

    onSuccess: ({ data: { template_creation_record, version_controls } }) => {
      queryClient.setQueryData<GetTemplateCreationRecordResponse>(
        [
          GET_TEMPLATE_CREATION_RECORD_BY_ID,
          { templateCreationRecordId: template_creation_record.id },
        ],
        {
          template_creation_record,
          version_controls,
        }
      );
    },
  });
};
